import { ProjectTypes } from '@actr/specs/src/project/types';

import config from '../configs';

class ProjectUtils {

  static isSber() {
    return config.projectType === ProjectTypes.SBER;
  }

  static isAkRedesign() {
    return config.projectType === ProjectTypes.AK_REDESIGN;
  }

  static isPartners() {
    return [ProjectTypes.SBER].includes(config.projectType);
  }

  static isWebview() {
    return config.projectType === ProjectTypes.WEBVIEW;
  }

  static isSkb() {
    return config.projectType === ProjectTypes.SKB;
  }

  static isVtb() {
    return config.projectType === ProjectTypes.VTB;
  }

  static isNordstar() {
    return config.projectType === ProjectTypes.NORDSTAR;
  }

  static isSmartflight() {
    return config.projectType === ProjectTypes.SMARTFLIGHT || config.projectType === ProjectTypes.KEY_TRAVEL;
  }

  static isKeyTravel() {
    return config.projectType === ProjectTypes.KEY_TRAVEL;
  }

  static isOtello() {
    return config.projectType === ProjectTypes.OTELLO;
  }

  static isPartnerWidget() {
    return config.projectType === ProjectTypes.PARTNER_WIDGET;
  }

  /** Проекты с новой страницей бронирования (AviaBookingRedesign) */
  static isBookingRedesign() {
    return [ProjectTypes.AK_REDESIGN, ProjectTypes.WEBVIEW].includes(config.projectType);
  }

}

export default ProjectUtils;
